module.exports = __webpack_public_path__ + "static/media/attack.491cce3d.png";